<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="size-3.5">
	<path d="M5 12h14M13 6l6 6-6 6" />
</svg>
